export const RESOURCE_SUBJECTS = ['All', 'Math', 'Science', 'English'];

export const RESOURCE_TYPE_META = {
  all: {
    id: 'all',
    label: 'All resources',
    helper: 'Entire locker',
    emoji: '🗂️',
    tone: 'neutral',
  },
  video: {
    id: 'video',
    label: 'Platform videos',
    helper: 'Deep dives & explainers',
    emoji: '🎬',
    tone: 'info',
  },
  session: {
    id: 'session',
    label: 'Private sessions',
    helper: 'Coach recaps & recordings',
    emoji: '🎧',
    tone: 'session',
  },
  worksheet: {
    id: 'worksheet',
    label: 'Worksheets',
    helper: 'Problem sets & drills',
    emoji: '📝',
    tone: 'worksheet',
  },
  material: {
    id: 'material',
    label: 'Learning material',
    helper: 'Guides & reading notes',
    emoji: '📚',
    tone: 'material',
  },
};

export const RESOURCE_TYPE_ORDER = ['all', 'video', 'session', 'worksheet', 'material'];

export const RESOURCE_LIBRARY = [
  {
    id: 'video-algebra-basics',
    type: 'video',
    title: 'Introduction to algebra: variables explained',
    subject: 'Math',
    duration: '9:14',
    views: '15K views',
    source: 'Minversity Studio',
    tags: ['Math', 'Platform'],
    detailLine: 'Minversity Studio · 15K views',
    summary: 'Algebra foundations with quick practice prompts.',
    addedOn: '2026-03-12',
    isNew: false,
    tone: 'math',
  },
  {
    id: 'video-fractions-made-easy',
    type: 'video',
    title: 'Fractions made easy: step-by-step',
    subject: 'Math',
    duration: '7:50',
    views: '9.1K views',
    source: 'Minversity Studio',
    tags: ['Math', 'Guide'],
    detailLine: 'Minversity Studio · 9.1K views',
    summary: 'Visual tips for simplifying and comparing fractions.',
    addedOn: '2026-03-19',
    isNew: true,
    tone: 'math',
  },
  {
    id: 'video-cell-structure',
    type: 'video',
    title: 'Cell structure: plant vs animal cells',
    subject: 'Science',
    duration: '12:05',
    views: '22K views',
    source: 'Minversity Studio',
    tags: ['Science', 'Lab'],
    detailLine: 'Minversity Studio · 22K views',
    summary: 'Compare cell organelles with lab footage overlays.',
    addedOn: '2026-03-22',
    isNew: true,
    tone: 'science',
  },
  {
    id: 'video-essay-structure',
    type: 'video',
    title: 'Essay structure: intro, body & conclusion',
    subject: 'English',
    duration: '7:33',
    views: '8.2K views',
    source: 'Minversity Studio',
    tags: ['English', 'Writing'],
    detailLine: 'Minversity Studio · 8.2K views',
    summary: 'Storyboard a compelling essay arc in under 10 minutes.',
    addedOn: '2026-03-15',
    isNew: false,
    tone: 'english',
  },
  {
    id: 'video-creative-story',
    type: 'video',
    title: 'Creative story lab: finding your narrative voice',
    subject: 'English',
    duration: '11:02',
    views: '12K views',
    source: 'Minversity Studio',
    tags: ['English', 'Creative'],
    detailLine: 'Coach Elina · 12K views',
    summary: 'Writing mentor Elina shares warm-up riffs & prompts.',
    addedOn: '2026-03-18',
    isNew: true,
    tone: 'english',
  },
  {
    id: 'session-fractions-deep-dive',
    type: 'session',
    title: 'Fractions & decimals deep dive (recorded)',
    subject: 'Math',
    coach: 'Priya Sharma',
    sessionDate: '2026-03-21',
    durationMinutes: 48,
    progressPercent: 64,
    status: 'Resume',
    detailLine: 'Priya Sharma · Math · 48 min · Mar 21',
    summary: 'Replay the 1:1 follow-up on fraction strategies.',
    addedOn: '2026-03-21',
    isNew: true,
    tone: 'math',
  },
  {
    id: 'session-photosynthesis',
    type: 'session',
    title: 'Photosynthesis & cell respiration breakdown',
    subject: 'Science',
    coach: 'Ravi Kumar',
    sessionDate: '2026-03-17',
    durationMinutes: 52,
    progressPercent: 100,
    status: 'Rewatch',
    detailLine: 'Ravi Kumar · Science · 52 min · Mar 17',
    summary: 'Lab recap plus annotated diagrams.',
    addedOn: '2026-03-17',
    isNew: false,
    tone: 'science',
  },
  {
    id: 'session-essay-hooks',
    type: 'session',
    title: 'Essay writing: hooks & thesis practice',
    subject: 'English',
    coach: 'Anita Rao',
    sessionDate: '2026-03-14',
    durationMinutes: 38,
    progressPercent: 15,
    status: 'Watch',
    detailLine: 'Anita Rao · English · 38 min · Mar 14',
    summary: 'Practice compelling introductions with Anita.',
    addedOn: '2026-03-14',
    isNew: false,
    tone: 'english',
  },
  {
    id: 'session-stem-clinic',
    type: 'session',
    title: 'STEM challenge clinic — robotics debugging',
    subject: 'Science',
    coach: 'Coach Dev',
    sessionDate: '2026-03-23',
    durationMinutes: 35,
    progressPercent: 0,
    status: 'Watch',
    detailLine: 'Coach Dev · Science · 35 min · Mar 23',
    summary: 'Live troubleshooting from the makerspace.',
    addedOn: '2026-03-23',
    isNew: true,
    tone: 'science',
  },
  {
    id: 'worksheet-fractions-a-b',
    type: 'worksheet',
    title: 'Chapter 7 – fractions practice set A & B',
    subject: 'Math',
    author: 'Priya Sharma',
    format: 'PDF',
    pages: 2,
    tags: ['Math', 'Practice'],
    detailLine: 'Priya Sharma · PDF · 2 pages · Mar 20',
    summary: 'Targeted drills for mixed numbers and word problems.',
    addedOn: '2026-03-20',
    isNew: true,
    tone: 'math',
  },
  {
    id: 'worksheet-speed-distance',
    type: 'worksheet',
    title: 'Speed & distance — word problems set',
    subject: 'Math',
    author: 'Priya Sharma',
    format: 'PDF',
    pages: 3,
    tags: ['Math', 'Practice'],
    detailLine: 'Priya Sharma · PDF · 3 pages · Mar 10',
    summary: 'Timed drills covering proportional reasoning.',
    addedOn: '2026-03-10',
    isNew: false,
    tone: 'math',
  },
  {
    id: 'material-unit4-notes',
    type: 'material',
    title: 'Unit 4 notes — cells & living organisms',
    subject: 'Science',
    author: 'Ravi Kumar',
    format: 'PDF',
    pages: 6,
    tags: ['Science', 'Notes'],
    detailLine: 'Ravi Kumar · PDF · 6 pages · Mar 18',
    summary: 'Lab-ready reference with diagrams and callouts.',
    addedOn: '2026-03-18',
    isNew: true,
    tone: 'science',
  },
  {
    id: 'material-the-giver-guide',
    type: 'material',
    title: 'The Giver — reading guide & discussion Qs',
    subject: 'English',
    author: 'Anita Rao',
    format: 'PDF',
    pages: 4,
    tags: ['English', 'Reading'],
    detailLine: 'Anita Rao · PDF · 4 pages · Mar 15',
    summary: 'Guided reflection prompts plus vocabulary boosts.',
    addedOn: '2026-03-15',
    isNew: false,
    tone: 'english',
  },
  {
    id: 'material-design-thinking',
    type: 'material',
    title: 'Design thinking cheatsheet — rapid ideation',
    subject: 'Science',
    author: 'Coach Mira',
    format: 'PDF',
    pages: 5,
    tags: ['Science', 'Projects'],
    detailLine: 'Coach Mira · PDF · 5 pages · Mar 11',
    summary: 'Framework + sticky-note exercises for makers.',
    addedOn: '2026-03-11',
    isNew: false,
    tone: 'science',
  },
];
